// Slider constructor (accepts DOM element directly)
function Slider(slider, opt = {}) {
  if (!slider) return

  const container = slider.querySelector('.slides')
  if (!container) return

  const btnPrev = slider.querySelector('.slider-prev')
  const btnNext = slider.querySelector('.slider-next')
  const slides = slider.querySelectorAll('.slide')

  if (!slides.length) return

  const threshold = opt.threshold || 30
  const slidesLength = slides.length

  let index = 0
  let allowShift = true

  // Prevent duplicate init
  if (slider.classList.contains('loaded')) return

  // Clone first + last
  const cloneFirst = slides[0].cloneNode(true)
  const cloneLast = slides[slidesLength - 1].cloneNode(true)

  container.appendChild(cloneFirst)
  container.insertBefore(cloneLast, slides[0])

  container.style.width = `${(slidesLength + 2) * 100}%`

  slider.classList.add('loaded')

  // Drag vars
  let posInitial, posFinal, posX1 = 0, posY = 0, posX2 = 0
  let counter = 0
  let dragging = false

  container.addEventListener('mousedown', dragStart)
  container.addEventListener('touchstart', dragStart, { passive: true })
  container.addEventListener('touchend', dragEnd)
  container.addEventListener('touchmove', dragAction)

  btnPrev && btnPrev.addEventListener('click', previous)
  btnNext && btnNext.addEventListener('click', next)

  container.addEventListener('transitionend', checkIndex)

  function next() {
    shift(++index)
  }

  function previous() {
    shift(--index)
  }

  function dragStart(e) {
    posInitial = container.offsetLeft
    counter = 0

    if (e.type === 'touchstart') {
      dragging = false
      posX1 = e.touches[0].clientX
      posY = e.touches[0].clientY
    } else {
      e.preventDefault()
      dragging = true
      posX1 = e.clientX
      posY = e.clientY
      document.addEventListener('mouseup', dragEnd)
      document.addEventListener('mousemove', dragAction)
    }
  }

  function dragAction(e) {
    counter++
    if (counter <= 4) return

    const { clientX, clientY } = e.type === 'touchmove' ? e.touches[0] : e

    if (!dragging && Math.abs(clientY - posY) > Math.abs(clientX - posX1)) return

    container.classList.add('dragging')
    dragging = true

    posX2 = posX1 - clientX
    posX1 = clientX
    container.style.left = `${container.offsetLeft - posX2}px`
  }

  function dragEnd(e) {
    e && e.preventDefault()

    counter = 0
    posFinal = container.offsetLeft

    if (posFinal - posInitial < -threshold) {
      shift(++index, 'drag')
    } else if (posFinal - posInitial > threshold) {
      shift(--index, 'drag')
    } else {
      container.style.left = `${posInitial}px`
    }

    container.classList.remove('dragging')
    document.removeEventListener('mouseup', dragEnd)
    document.removeEventListener('mousemove', dragAction)
  }

  function shift(newIndex, action) {
    if (!allowShift) return

    container.classList.add('shifting')

    if (!action) posInitial = container.offsetLeft

    index = newIndex
    container.style.left = `${(index + 1) * -100}%`
    allowShift = false
  }

  function checkIndex() {
    container.classList.remove('shifting')

    index = (index + slidesLength) % slidesLength
    container.style.left = `${(index + 1) * -100}%`

    allowShift = true
    checkDots()
  }

  function jumpTo(i) {
    if (i < 0 || i >= slidesLength) return
    shift(i)
  }

  function checkDots() {
    if (!opt.dots) return
    slider.querySelectorAll(`${opt.dots} span`).forEach((dot, i) => {
      dot.classList.toggle('active', i === index)
    })
  }

  // Dots
  if (opt.dots) {
    const dots = slider.querySelector(opt.dots)
    if (dots) {
      dots.innerHTML = ''

      for (let i = 0; i < slidesLength; i++) {
        const dot = document.createElement('span')
        dot.addEventListener('click', () => {
          jumpTo(i)
          checkDots()
        })
        dots.appendChild(dot)
      }

      checkDots()
    }
  }

  return { jumpTo, shift, previous, next }
}

// Init sliders (supports multiple sections + Shopify reloads)
function initExploreSliders() {
  document.querySelectorAll('.explore_slider').forEach(sliderEl => {
    Slider(sliderEl, {
      dots: '.slider-dots',
    })
  })
}

document.addEventListener('DOMContentLoaded', initExploreSliders)

// Shopify theme editor support
document.addEventListener('shopify:section:load', initExploreSliders)
